/* eslint-disable no-undef */
import { useLoaderData } from "react-router-dom";
import AppWrapper from "../../../components/cm/AppWrapper";
import SideBarMain from "../../../components/cm/SideBarMain";
import ViewDocuments from "../../../components/modules/Documents/ViewDocuments";
import useParentLoaderData from "../../../hooks/useParentLoaderData";

export default () => {
  return (
      <AppWrapper.WithSidebar sidebar={<SideBarMain />}>
        <ViewDocuments/>
      </AppWrapper.WithSidebar>
  );
};
